exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".videoWrapper{height:0;padding-bottom:56.25%;padding-top:25px;position:relative;max-width:800px;margin-left:auto;margin-right:auto}.videoWrapper iframe{height:100%;left:0;position:absolute;top:0;width:100%}.video-cloudfront{display:block;margin:0 auto;max-width:100%;height:auto;background-color:#000}.video-caption{font-size:0.9em;color:#959595;text-align:center;margin:8px 0}.video-embed{margin-left:auto;margin-right:auto;max-width:800px}.video-embed--portrait{margin-left:auto;margin-right:auto;max-width:min(100%, 400px, calc(56.25vh - 140.625px));min-width:250px}@media print{.videoWrapper,.video-embed,.video-cloudfront,.video-caption,.content-extra__video{display:none !important}}\n", ""]);

// exports
exports.locals = {
	"videoWrapper": "videoWrapper",
	"video-cloudfront": "video-cloudfront",
	"video-caption": "video-caption",
	"video-embed": "video-embed",
	"video-embed--portrait": "video-embed--portrait",
	"content-extra__video": "content-extra__video"
};